import { useEffect, useState } from 'react';

/**
 * Turns true only after `flag` has stayed true for `delay` ms, so loading
 * skeletons never flash on fast responses (book §11.15). Turns false at once.
 */
export const useDelayedFlag = (flag: boolean, delay = 300) => {
  const [delayed, setDelayed] = useState(false);
  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setDelayed(true), delay);
    return () => window.clearTimeout(timer);
  }, [flag, delay]);
  return flag && delayed;
};
